import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import Banner from "components/home/Banner";
import HomeCategory from "components/home/HomeCategory";
import EmailModal from "../email/EmailModal";
import CATEGORIES from "utils/categories";
import { ACTION_TYPE } from "reducers/actionType";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";
import { atLeastOneContributor, isPopulated } from "utils/helpers";

import "styles/Home.scss";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
    };
    this.moduleRef = React.createRef();
  }

  showModal = () => this.setState({ modalVisible: true });
  closeModal = () => this.setState({ modalVisible: false });
  handleContinue = () => this.closeModal();

  clearRecommendations = () => {
    this.props.dispatch({
      type: ACTION_TYPE.recommendationsFetch.success,
      data: {
        recommendations: [],
        loading: false,
      },
    });
  };

  renderAtarEligibility = () => (
    <div className="atar-eligibility-container">
      <div className="eligibility-prompt">
        If you know the HSC subjects you’d like to take, check your ATAR
        eligibility
      </div>
      {/* this should not be a simple navlink
      if this page was populated with previous, make sure to clear the contents  */}
      <NavLink to="/summary" name="/summary">
        <MasterButton
          type={BUTTON_TYPES.GHOST}
          text="Check ATAR Eligibility"
          callback={this.clearRecommendations}
          small={true}
          style={{ width: 260 }}
        />
      </NavLink>
    </div>
  );

  render() {
    return (
      <div className="home">
        <Banner />

        <div className="vertical-grey-line desktop-and-tablet" />
        <div className="home-module-container" ref={this.moduleRef}>
          {CATEGORIES.map((cat, i) => (
            <NavLink
              key={i}
              to={`/${cat.navlink}`}
              name={`/${cat.navlink}`}
              className="home-category"
            >
              <HomeCategory
                {...cat}
                active={false}
                complete={isPopulated(cat)}
              />
            </NavLink>
          ))}
          {atLeastOneContributor() && (
            <NavLink to="/studies">
              <div className="home-module-bottom">View Subjects</div>
            </NavLink>
          )}
        </div>
        <div className="vertical-grey-line desktop-and-tablet" />
        {!atLeastOneContributor() && this.renderAtarEligibility()}
        <EmailModal
          modalVisible={this.state.modalVisible}
          closeModal={this.closeModal}
          handleContinue={this.handleContinue}
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  const { userInterests } = store.interestsReducer;
  const { userSkills } = store.skillsReducer;
  const { userPersonality } = store.personalityReducer;
  const { userCareers } = store.careersReducer;
  const { userCourses } = store.coursesReducer;

  return {
    userInterests,
    userSkills,
    userPersonality,
    userCareers,
    userCourses,
  };
};
export default connect(mapStateToProps)(Home);
